import { render, staticRenderFns } from "./BaseHeaderNotification.vue?vue&type=template&id=c1ac4ee6&scoped=true&"
import script from "./BaseHeaderNotification.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderNotification.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderNotification.vue?vue&type=style&index=0&id=c1ac4ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ac4ee6",
  null
  
)

export default component.exports